
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/employer/venues",
      function () {
        return require("private-next-pages/employer/venues/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/employer/venues"])
      });
    }
  